import React, { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import { LoginRedirectDialogBox } from './LoginRedirectDialogBox';
import Loader from './Loader';

export function LoginRedirect() {

    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        if (isAuthenticated === false && !urlParams.has('redirect_to_login')) {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }, [isAuthenticated])

    useEffect(() => {
        if (urlParams.has('redirect_to_login')) setShowLogin(true);
    }, [urlParams])

    useEffect(() => {
        if (showLogin) {
            var modal1 = document.getElementById("loginModal");
            modal1.style.display = "block";
        }
    }, [showLogin])

    return (
        <>
            {showLogin ?
                <LoginRedirectDialogBox /> :
                <Loader />
            }
        </>
    );
}